// =============================================================================
// Environment Configuration
// Centralizes all environment variable access
// =============================================================================

export interface AuthConfig {
  turnstileSiteKey: string;
  turnstileEnabled: boolean;
  signupEnabled: boolean;
  sso: { google: boolean; microsoft: boolean };
}

export const env = {
  api: {
    baseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api',
  },
  appInsights: {
    connectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING ?? '',
  },
} as const;

let cachedAuthConfig: AuthConfig | null = null;

export async function fetchAuthConfig(): Promise<AuthConfig> {
  if (cachedAuthConfig) return cachedAuthConfig;

  const response = await fetch(`${env.api.baseUrl}/config/auth`);
  if (!response.ok) {
    throw new Error(`Failed to fetch auth config: ${response.status}`);
  }

  const config = await response.json();
  cachedAuthConfig = {
    turnstileSiteKey: config.turnstileSiteKey ?? '',
    turnstileEnabled: config.turnstileEnabled ?? false,
    signupEnabled: config.signupEnabled ?? false,
    sso: {
      google: config.sso?.google ?? false,
      microsoft: config.sso?.microsoft ?? false,
    },
  };
  return cachedAuthConfig;
}
